import { useV2ListPsaIntegrationsQuery } from "@generated";
import { ResolvedIntegration } from "../types/PsaProject";

export const usePsaIntegrations = () => {
  const { data, isLoading } = useV2ListPsaIntegrationsQuery();

  const integrations: ResolvedIntegration[] = (data?.data ?? [])
    .map((resource: any): ResolvedIntegration | null => {
      const accountConnectionId =
        resource?.relationships?.["account-connection"]?.data?.id;
      if (!accountConnectionId) return null;
      const settings = resource?.attributes?.settings ?? {};
      const service = resource?.attributes?.service ?? settings.service ?? "";
      return {
        id: String(resource.id),
        service,
        accountConnectionId: String(accountConnectionId),
        settings,
        label: `${service} / ${accountConnectionId}`,
      };
    })
    .filter((i): i is ResolvedIntegration => i !== null);

  return { integrations, isLoading };
};
